// extracted by mini-css-extract-plugin
export default {"captchaContainer":"captcha_captchaContainer__222fU","captchaChip":"captcha_captchaChip__ejsRI","captchaRefreshIcon":"captcha_captchaRefreshIcon__7azJy"};